createQueryPreloader